/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebDeleteFavoriteModel,
  IWebDeleteFavoriteRequest,
  IMappers,
  IWebDeleteFavoriteResponse,
  IWebDeleteFavoriteResponseError,
  TWebDeleteFavoriteResponse,
} from './types';

const defaultConfig: TWebDeleteFavoriteModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/delete-favorite/',
  hostType: 'api',
} as TWebDeleteFavoriteModel;

function createWebDeleteFavoriteModel(parameters: IWebDeleteFavoriteRequest): TWebDeleteFavoriteModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebDeleteFavoriteOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IWebDeleteFavoriteRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchWebDeleteFavorite<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebDeleteFavoriteOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TWebDeleteFavoriteResponse
> {
  const { response, statusCode } = await httpApi.fetch(createWebDeleteFavoriteModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IWebDeleteFavoriteResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IWebDeleteFavoriteResponseError);
    }
  }

  return { response, statusCode } as TWebDeleteFavoriteResponse;
}

export { defaultConfig, createWebDeleteFavoriteModel, fetchWebDeleteFavorite };
